import { Link } from 'react-router-dom';
import { actionIcons, logo } from '../../../../../configs/Icons';
import { useInit } from '../../../../Contexts/InitProvider';
import { useMenus } from '../../MenuProvider';

function HeaderLeftCol() {
    const { handleMenuCollapse } = useMenus();

    const { initInfo } = useInit();
    return (
        <div className="header_left-side">
            <div className="header-logo w-14 sm:w-24 md:w-32 h-10">
                <Link to="/" className="size-full">
                    <img
                        src={initInfo?.adminLogo || logo.mainLogoW}
                        alt="Next"
                        className="size-full"
                    />
                </Link>
            </div>
            <div
                className="header-bars w-4 md:w-7 cursor-pointer"
                role="button"
                tabIndex={-1}
                onClick={handleMenuCollapse}
            >
                <img src={actionIcons.barsW} alt="Toggle" />
            </div>
        </div>
    );
}

export default HeaderLeftCol;
